<template>
   <div id="" class="theme app scroll">
      <LayoutAplication>
         <transition name="fade" mode="out-in">
            <router-view></router-view>
         </transition>

         <transition name="fade" mode="out-in">
            <AdviceLogOutModal @closeModal="isLogoutModalOpen = false" v-if="isLogoutModalOpen" />
         </transition>
         <transition name="fade" mode="out-in">
            <AdviceConfirmSaveAdvices v-if="isConfirmAdvices" />
         </transition>
         <PWAprompt @cancel="cancel" :isInstallPWA.sync="isInstallPWA" />
      </LayoutAplication>
   </div>
</template>

<script>
import AdviceLogOutModal from '../../components/AdviceComponents/AdviceLogOutModal.vue';
import AdviceConfirmSaveAdvices from '../../components/AdviceCategoriesComponents/AdviceConfirmSaveAdvices.vue';
import mutations from '../../store/mutation-types';
import LayoutAplication from '../../components/Layouts/LayoutAplication.vue';
import PWAprompt from '../../components/AppComponents/PWAprompt.vue';

export default {
   provide() {
      return {
         setCurrentTheme: this.setCurrentTheme,
         getCurrentFontSize: this.getCurrentFontSize,
         openLogoutModal: this.openLogoutModal,
         installPWA: this.installPWA,
         cancelPWA: this.cancel,
      };
   },

   components: {
      AdviceLogOutModal,
      AdviceConfirmSaveAdvices,
      LayoutAplication,
      PWAprompt
   },

   data() {
      return {
         fontSize: {
            small: 20,
            medium: 22,
            large: 28,
         },
         isLogoutModalOpen: false,
         prev: 0,
         isInstallPWA: false,
      };
   },

   computed: {
      isConfirmAdvices() {
         return this.$store.getters['advice/getIsConfirmAdvices'];
      },
   },

   created() {
      this.getCurrentFontSize();
   },

   mounted() {
      //this.setCurrentTheme();

      const scrollElem = document.querySelector('.scroll');
      scrollElem.addEventListener('scroll', this.scollChecker);

   },

   methods: {
      setCurrentTheme() {
         let theme = localStorage.theme ? localStorage.theme : '';
         document.querySelector('.theme').style.transition = 'all 0.3s';
         document.querySelector('.theme').setAttribute('id', localStorage.theme);
         return theme;
      },

      getCurrentFontSize() {
         if (!localStorage.fontSize) localStorage.fontSize = 'medium';
         let font = this.fontSize[localStorage.fontSize];
         this.$store.commit(`advice/${mutations.UPDATE_FONT_SIZE}`, font);
         return font;
      },

      openLogoutModal() {
         this.isLogoutModalOpen = true;
      },

      scollChecker(e) {
         const pxelsScrollToUpdate = 100;
         if (
            this.prev + pxelsScrollToUpdate < e.target.scrollTop ||
            this.prev - pxelsScrollToUpdate > e.target.scrollTop
         ) {
            this.$store.commit('advice/updateScroll', true);
            this.prev = e.target.scrollTop;
         } else {
            this.$store.commit('advice/updateScroll', false);
         }
      },
      installPWA() {
         this.isInstallPWA = true;
      },

      cancel() {
         this.isInstallPWA = false;
      },
   },
};
</script>

<style lang="sass" scoped>
@import '../../sass/_variables'
.app
	height: 100%
	width: 100%
	// overflow-y: auto

#sepia
	background-color: $app-sepia-background

#dark
	background-color: $app-dark-background
</style>
